var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"mb-4"},[_c('v-tabs',{attrs:{"align-with-title":""}},[_c('v-tab',{attrs:{"to":"/admin/data/artworks"}},[_vm._v("List")])],1),_c('router-view',{staticClass:"view"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }